var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2323 3.0625H6.92212C4.76403 3.0625 3.0083 4.81823 3.0083 6.97632V12.2865C3.0083 14.4446 4.76403 16.2003 6.92212 16.2003H12.2323C14.3904 16.2003 16.1461 14.4446 16.1461 12.2865V6.97632C16.1461 4.81823 14.3903 3.0625 12.2323 3.0625ZM14.8244 12.2865C14.8244 13.7181 13.6639 14.8786 12.2323 14.8786H6.92212C5.49052 14.8786 4.32996 13.7181 4.32996 12.2865V6.97632C4.32996 5.5447 5.49052 4.38416 6.92212 4.38416H12.2323C13.6639 4.38416 14.8244 5.5447 14.8244 6.97632V12.2865Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5771 6.23438C7.70349 6.23438 6.1792 7.75867 6.1792 9.63225C6.1792 11.5058 7.70349 13.0301 9.5771 13.0301C11.4507 13.0301 12.975 11.5059 12.975 9.63225C12.975 7.75865 11.4507 6.23438 9.5771 6.23438ZM9.5771 11.7085C8.43041 11.7085 7.50086 10.779 7.50086 9.63227C7.50086 8.48559 8.43044 7.55604 9.5771 7.55604C10.7238 7.55604 11.6533 8.48559 11.6533 9.63227C11.6533 10.7789 10.7238 11.7085 9.5771 11.7085Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9817 7.07373C13.4314 7.07373 13.7959 6.70919 13.7959 6.25952C13.7959 5.80985 13.4314 5.44531 12.9817 5.44531C12.532 5.44531 12.1675 5.80985 12.1675 6.25952C12.1675 6.70919 12.532 7.07373 12.9817 7.07373Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-Icon.7295a3d375b372777912bbc7275fdc19.svg";
export { ForwardRef as ReactComponent };